
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 13.091c0-5.2 4.061-9.471 9.234-9.87v-.664H9.375a.773.773 0 01-.785-.779c0-.436.345-.778.785-.778h5.173c.44 0 .785.342.785.778a.773.773 0 01-.785.779h-1.743v.664a9.95 9.95 0 015.114 1.88l.863-.855-.364-.36a.774.774 0 010-1.102.791.791 0 011.11 0l1.82 1.804a.774.774 0 010 1.1.771.771 0 01-.555.228.771.771 0 01-.555-.227l-.364-.361-.786.778A9.827 9.827 0 0122 13.092C22 18.558 17.517 23 12 23S2 18.558 2 13.091zM12 4.74c-4.655 0-8.448 3.74-8.448 8.371 0 4.613 3.793 8.372 8.448 8.372s8.448-3.759 8.448-8.372c0-4.612-3.793-8.37-8.448-8.37zm0 8.998a.77.77 0 01-.785-.76V8.176c0-.436.344-.778.785-.778.44 0 .785.342.785.778v4.005h2.567c.441 0 .786.342.786.779a.773.773 0 01-.786.778H12z","fill":"currentColor"}})])
          )
        }
      }
    